import { SVGAttributes } from 'react';

export const Payment = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" {...props}>
      <path
        fill="#595a66"
        d="M29 0H9C7.3 0 6 1.3 6 3v38c0 1.7 1.3 3 3 3h20c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
      />
      <path
        fill="#494a52"
        d="M31 .8V41c0 1.1-.9 2-2 2H8c-.6 0-1.1-.2-1.6-.4C7 43.4 7.9 44 9 44h20c1.7 0 3-1.3 3-3V3c0-.9-.4-1.7-1-2.2z"
      />
      <path
        fill="#70b7e5"
        d="M30 8v29c0 .5-.4 1-1 1H9c-.6 0-1-.4-1-1V8c0-.5.4-1 1-1h20c.6 0 1 .4 1 1z"
      />
      <path
        fill="#4c9cd6"
        d="M29 7H9c-.6 0-1 .4-1 1v1c0-.5.4-1 1-1h20c.6 0 1 .4 1 1V8c0-.6-.4-1-1-1z"
      />
      <circle cx="19" cy="41" r="1" fill="#35363e" />
      <path fill="#90cef1" d="M9 37v-5l5 5zM9 30l7 7h2l-9-9z" />
      <path
        fill="#6f707e"
        d="M7 37.6c0 .9-.4 1.8-1 2.4V20.6c.6.6 1 1.5 1 2.4v14.6zM12.4 1c-.9 0-1.8-.4-2.4-1h16c-.6.6-1.5 1-2.4 1H12.4z"
      />
      <path
        fill="#35363e"
        d="M21.5 4h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zM14.5 3c.3 0 .5.2.5.5s-.2.5-.5.5-.5-.2-.5-.5.2-.5.5-.5z"
      />
      <path
        fill="#f37321"
        d="M36 29H18c-1.1 0-2-.9-2-2V15c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2z"
      />
      <path fill="#f79548" d="M25 29h-6l7-16h6zM28 29h-2l7-16h2z" />
      <path
        fill="#ea5434"
        d="M25.5 25h-7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7c.3 0 .5.2.5.5s-.2.5-.5.5z"
      />
      <path
        fill="#f37321"
        d="M25.5 25c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4.3l-.4 1h4.7z"
      />
      <path
        fill="#ea5434"
        d="M22.5 27h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5z"
      />
      <path
        fill="#f37321"
        d="M22.5 27c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2.2l-.4 1h2.6z"
      />
      <path fill="#014463" d="M16 16h22v4H16z" />
      <path fill="#0b5068" d="M29.9 20h2l1.8-4h-2zM22.9 20h6l1.8-4h-6z" />
      <path fill="#494a52" d="M30 29h1v1h-1z" />
      <path fill="#4c9cd6" d="M18 29c.6.6 1.5 1 2.4 1H30v-1H18z" />
    </svg>
  );
};
